import { Address } from './Address';
import { Contact } from './Contact';
import { DiscardableModel } from './DiscardableModel';
import { EmailTemplateLink } from './EmailTemplate';
import { Employee } from './Employee';
import { EmployeeRequirement } from './EmployeeRequirement';
import { ErroredModel } from './ErroredModel';
import { Field } from './FieldCommon';
import { Integration } from './Integration';
import { TaggableModel } from './Tag';
import { Task } from './Task';
import { PaginationMeta } from './pagination';

export enum EventStatus {
  PLANNING = 'Planning',
  SCHEDULED = 'Scheduled',
  IN_PROGRESS = 'In progress',
  COMPLETE = 'Complete',
  CANCELLED = 'Cancelled'
}

export interface ConflictEmployeeEvent {
  event_uuid: string;
  event_display_name: string;
}

export interface EventEmployee {
  employee: Employee;
  conflict_employee_events?: ConflictEmployeeEvent[];
}

export type Event = ErroredModel &
  TaggableModel &
  DiscardableModel & {
    uuid: string;
    new_record?: boolean;
    start_at: string;
    end_at: string;
    status: EventStatus;
    display_name: string;
    account_uuid: string;
    account_name: string;
    account_display_name: string;
    account_code?: string;
    event_template_uuid?: string;
    event_template_name?: string;
    parent_uuid?: string;
    parent_name?: string;
    type_uuid: string;
    type_value: string;
    location_uuid: string;
    location_value: string;
    calendar_event_id: string;
    outlook_calendar_event_id: string;
    tasks: Task[];
    fields: Field[];
    event_email_templates: EmailTemplateLink[];
    integrations: Integration[];
    event_employees: EventEmployee[];
    employee_requirements?: EmployeeRequirement[];
    contacts: Contact[];
    name: string;
    address?: Address;
    is_full_day?: boolean;
    multi_child: boolean;
    multi_parent: boolean;
    children: Event[];
    event_template_parent_child_uuid?: string;
    event_template_parent_child_offset?: number;
  };

export type EventResponse = {
  data: Event[];
  meta: PaginationMeta;
};

export interface EventItemQueryParams {
  account?: string;
  template?: string;
}

export enum EventTimeSpan {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  WEEK = 'week',
  UPCOMING = 'upcoming',
}
